import React from 'react';
import {
  Box,
  Typography,
  Switch,
  Avatar,
  useTheme,
  alpha,
} from '@mui/material';

const PreferenceToggle = ({ label, checked, onChange, description, icon }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{
      mb: 4,
      px: 3,
      py: 2,
      backgroundColor: alpha(theme.palette.background.paper, 0.6),
      borderRadius: 2,
      border: `1px solid ${alpha(checked ? theme.palette.primary.main : theme.palette.divider, checked ? 0.3 : 0.1)}`,
      transition: 'all 0.3s ease',
      boxShadow: checked
        ? `0 4px 12px ${alpha(theme.palette.primary.main, 0.15)}`
        : '0 2px 8px rgba(0,0,0,0.03)',
      position: 'relative',
      overflow: 'hidden',
      '&:hover': {
        boxShadow: checked
          ? `0 6px 16px ${alpha(theme.palette.primary.main, 0.2)}`
          : '0 4px 12px rgba(0,0,0,0.06)',
        transform: 'translateY(-2px)',
      },
    }}>
      {checked && (
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.palette.primary.main,
          opacity: 0.03,
          zIndex: 0,
        }} />
      )}

      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        mb: 1.5,
        zIndex: 1,
        position: 'relative',
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {icon && (
            <Avatar
              sx={{
                width: 36,
                height: 36,
                bgcolor: checked
                  ? alpha(theme.palette.primary.main, 0.1)
                  : alpha(theme.palette.action.hover, 0.1),
                color: checked ? theme.palette.primary.main : theme.palette.text.secondary,
                transition: 'all 0.3s ease',
              }}
            >
              {icon}
            </Avatar>
          )}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: { xs: '0.95rem', sm: '1.05rem' },
              color: checked ? theme.palette.primary.main : theme.palette.text.primary,
              transition: 'all 0.3s ease',
            }}
          >
            {label}
          </Typography>
        </Box>

        <Switch
          checked={checked}
          onChange={onChange}
          color="primary"
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              transform: 'translateX(16px)',
              color: theme.palette.common.white,
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: theme.palette.primary.main,
              opacity: 0.8,
            }
          }}
        />
      </Box>

      {description && (
        <Typography
          variant="body2"
          color={checked ? 'text.primary' : 'text.secondary'}
          sx={{
            fontSize: { xs: '0.8rem', sm: '0.85rem' },
            ml: icon ? 7 : 0,
            position: 'relative',
            zIndex: 1,
            opacity: checked ? 0.9 : 0.7,
            transition: 'all 0.3s ease',
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default PreferenceToggle;

